// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable no-restricted-imports, multiline-comment-style, func-names, new-cap, babel/new-cap */
// FIXME: remove this disable directive and fix the ESLint error(s)

// @ts-expect-error: Flow to TS migration.
import _ from "lodash"
import { List } from "immutable"
import type { List as ListType } from "immutable"
import cuckoo from "@kiwicom/frontend-common/services/cuckoo/cuckoo"
import mapperJourney from "@kiwicom/frontend-common/services/journey/mapperJourney"
import { cuckooEvents } from "@kiwicom/frontend-common/consts/enums"
import type Journey from "@kiwicom/frontend-common/records/Journey"
import { getAirlines } from "@kiwicom/frontend-common/services/staticData"

/*
 * @returns {OrderedMap<version, Journey>} - history versions with their respectable journey change
 */
// Fix this the next time the file is edited. (Flow to TS)
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function (input: any): ListType<Journey> | null | undefined {
  try {
    // NOTE!!!
    // This is a terrible idea and only here as a god damn hotfix
    // If I see anyone else doing this shit he's gonna have to explain himself
    // in front of every FE dev eye to eye as a shaming ritual
    // @ts-expect-error: Flow to TS migration.
    const airlines = getAirlines(window.__INITIAL_STATE__)

    return _.reduce(
      input,
      // FIXME: a method has been detected that possibly mutates the object, consider a more
      // functional approach (Ramda might help)

      // @ts-expect-error: Flow to TS migration.
      (acc, journey) => acc.push(mapperJourney(journey, "", false, airlines)),
      List(),
    )
    // Fix this the next time the file is edited. (Flow to TS)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (err: any) {
    cuckoo.error(cuckooEvents.INTERNAL_MAPPER_FLIGHTS_HISTORY_UNSUPPORTED_FORMAT, { input, err })

    return null
  }
}
